
export enum QuizUserRequire {
  OSH = 'requireOsh',
  KNF = 'requireKnf',
  STMT = 'requireStmt',
  ETHIC = 'requireEthic',
  BANK_STMTS = 'requireBankStmt'
}

export enum QuizType {
  KNF = 'KNF',
  OSH = 'BHP',
  STMT = 'STMT',
  ETHIC = 'ETHIC',
}

export enum QuizTypeName {
  OSH = 'BHP',
  KNF = 'KNF',
  ETHIC = 'Etyka',
}

export enum QuizCategory {
  KNF = 'knf',
  OSH = 'osh',
  STMT = 'stmt',
  ETHIC = 'ethic',
  BANK_STMTS = 'bankStmt',
  UNI_CREDIT = 'uniCredit'
}

/**
 * Pole `kind` z `GET /quiz` — dzieli kategorie na cykliczne (odnawiane, z blokadą kadrową)
 * i jednokrotne. BE serializuje enum PascalCase-em (`Cyclical` / `OneOff`), dlatego porównania
 * idą przez `isQuizKind` — bez tego sekcja jednokrotnych nigdy się nie renderuje.
 */
export enum QuizKind {
  CYCLICAL = 'Cyclical',
  ONE_OFF = 'OneOff'
}

export const isQuizKind = (value: Nullable<string> | undefined, kind: QuizKind): boolean =>
  (value ?? '').toLowerCase() === kind.toLowerCase();

/**
 * Kategorie jednokrotne: akceptacja jest dobrowolna, nie odnawia się i nie blokuje kadrowo.
 * BE nie zwraca dla nich flag `require*` w `users/me`, a `allowReattemptAt`/`hrLockAt` na próbie
 * są zawsze `null` — dlatego typy `Quizzes*` poniżej celowo obejmują tylko kategorie cykliczne
 * (patrz `DictionaryStore.canFetchDictionary`, gdzie każda nieznana flaga `require*` = blokada).
 */
export type OneOffQuizCategory = QuizCategory.UNI_CREDIT;
export type CyclicalQuizCategory = Exclude<QuizCategory, OneOffQuizCategory>;

export type QuizzesRequire = {
  [K in CyclicalQuizCategory as `require${Capitalize<K>}`]: boolean;
}

export type QuizzesRequireHrLockAt = {
  [K in CyclicalQuizCategory as `require${Capitalize<K>}HrLockAt`]?: Date;

}
export const NotInstantBlockQuizzes: (keyof QuizzesRequire)[] = ['requireStmt', 'requireEthic', 'requireBankStmt', 'requireKnf'];
